import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getter'
// import app from './modules/app'
// import settings from './modules/settings'
import login from './modules/login'
import makerlogin from './modules/makerlogin'
import tagsView from './modules/tagsView'
Vue.use(Vuex)

const store = new Vuex.Store({
  state:{
      themecolor:localStorage.getItem('ztColor') ? localStorage.getItem('ztColor') : 'fa541c'//默认为20a0ff
  },
  mutations:{
      //更新主题颜色
      setThemeColor(state,curcolor){
          this.state.themecolor = curcolor;
      }
  },
  modules: {
    // app,
    // settings,
    login,
    makerlogin,
    tagsView
  },
  getters
})

export default store